var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuyudingyi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631325",
    x: 1.8125,
    y: 1.3125,
    width: 13.375,
    height: 13.375,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 89",
    cx: 6.90625,
    cy: 9.40625,
    r: 3.21875,
    fill: "#D9D9D9",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 12",
    d: "M9.76508 3.89548C9.95508 3.55025 10.4512 3.55025 10.6412 3.89548L13.3607 8.83705C13.5441 9.17028 13.303 9.57812 12.9227 9.57812H7.48358C7.10322 9.57812 6.86215 9.17028 7.04554 8.83705L9.76508 3.89548Z",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuyudingyi);
export default __webpack_public_path__ + "static/media/quyudingyi.7d1e0f41198616ae393f94a4c9c658db.svg";
export { ForwardRef as ReactComponent };